import { PageContainer } from '../../components/layout/PageContainer.js';

export interface ScaffoldPageProps {
  readonly title: string;
  readonly note: string;
}

export function ScaffoldPage({ title, note }: ScaffoldPageProps): JSX.Element {
  return (
    <PageContainer>
      <h1 className="font-mono text-lg mb-2">{title}</h1>
      <p className="text-sm text-text-dim">{note}</p>
    </PageContainer>
  );
}
